import React ,{useRef} from 'react'
import "./Header.css"
import { portfolio2} from "../../images"
import Facts from './Facts'
import gsap from 'gsap'
import {useGSAP} from '@gsap/react'

const Header = () => {
  const container = useRef(null)
  gsap.registerPlugin(useGSAP)
useGSAP(() => {
  
  gsap.fromTo(".profile__wrapper",     
    { scale: 0.5, opacity: 0.5 },
    { scale: 1, opacity: 1, duration: 1, ease: "sine.in", clearProps: "all" }
  );

  gsap.from(".intro__text", {
    fontSize: 100,
    duration: 1,
    delay: 1,
    ease: "sine.in",
    clearProps: "all",
  });

  const tl = gsap.timeline();
  tl.from(".header__info__top", { opacity: 0, clearProps: "all" })
    .from(".header__title", { opacity: 0, y: -30, clearProps: "all" })
    .from(".header__description", { opacity: 0, clearProps: "all" })
    .from(".header__info__bottom .btn", {
      x: -40,
      opacity: 0,
      stagger: 0.2,
      clearProps: "all",
    });
}, { scope: container });

  return (
    <header id='header' className='blur-effect' ref={container}>
      <div className="stroke__text intro__text">HELLO</div>

      <div className="section__wrapper header__container">
        <div className="column intro__container blur-effect">
          <div className="header__info">
            <div className="header__info__top">
              HELLO! I'M <span className="color_primary">MAHSHID SHIRAZI</span>
            </div>

            <div className="header__info__middle">
              <h1 className="primary__title header__title">I'M A JUNIOR SOFTWARE DEVELOPER</h1>
              <p className="text__muted header__description">
                Junior Software Developer with a focus on learning best practices, writing maintainable code, and developing scalable applications.
              </p>
            </div>
<Facts />
            <div className="header__info__bottom">
  <a
    href="/Mahshid_Shirazi_Resume.pdf"
    className="btn btn_primary"
    download="Mahshid_Shirazi_Resume.pdf"
    target="_blank"
    rel="noreferrer"
  >
    Download Resume
  </a>

  <a href="mailto:sheedshirazi@gmail.com" className="btn">Contact Me</a>
</div>

          </div>
        </div>
        <div className="column profile__wrapper">
          <img src={portfolio2} className="portfolio__photo" alt="Mahshid Shirazi" />
        </div>
      </div>
    </header>
  )
}

export default Header
